import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { StatefulComponent } from '../../components/stateful/stateful.component';
import { InputComponent } from '../../components/input/input.component';
import { AuthorizeService } from '../../services/authorize.service';
import { AlertService } from '../../services/alert.service';
import { setContainerTypeAction, showLoadingMaskAction } from '../../ngrx/actions/global.actions';

/**
 * Forgot-password entry: collects an email and requests a reset link. The
 * response is always the same generic confirmation (the API never reveals
 * whether an account exists).
 */
@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterLink, InputComponent],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent extends StatefulComponent implements OnInit {

  forgotForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  submitted = false;

  constructor(
    private authorizeService: AuthorizeService,
    private alertService: AlertService
  ) {
    super();
  }

  ngOnInit(): void {
    this.dispatch(setContainerTypeAction({ containerType: 'normal' }));
  }

  onSubmit(): void {
    if (!this.forgotForm.valid) {
      this.forgotForm.get('email')?.markAsDirty();
      this.alertService.showSnackBar('Please enter a valid email address.');
      return;
    }

    this.dispatch(showLoadingMaskAction({ showLoadingMask: true }));
    this.subs.push(
      this.authorizeService.forgotPassword(this.forgotForm.get('email')?.value).subscribe({
        next: () => {
          this.dispatch(showLoadingMaskAction({ showLoadingMask: false }));
          this.submitted = true;
        },
        error: (error) => {
          console.error('[ForgotPassword] Request failed:', error);
          this.dispatch(showLoadingMaskAction({ showLoadingMask: false }));
          // Show the same confirmation regardless — never confirm or deny
          // that an account exists.
          this.submitted = true;
        }
      })
    );
  }
}
